import { render, staticRenderFns } from "./MasterLogin.vue?vue&type=template&id=f1fa5f76&scoped=true&lang=pug"
import script from "./MasterLogin.vue?vue&type=script&lang=js"
export * from "./MasterLogin.vue?vue&type=script&lang=js"
import style0 from "./MasterLogin.vue?vue&type=style&index=0&id=f1fa5f76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fa5f76",
  null
  
)

export default component.exports